import React,{ useEffect, useState } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { useLocation } from "react-router-dom";

const isTruthyQueryValue = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  return normalized === "true" || normalized === "1" || normalized === "yes";
};

function USER({children }) {
  const dispatch = useDispatch();
    const location = useLocation();

    const {companyLogoUrl,backButtonUrl} = useSelector(state => state.ui);
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { user } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
    const queryFromMobileApp = isTruthyQueryValue(new URLSearchParams(location.search).get("fromMobileApp"));
    const mobileAppSessionFlag = sessionStorage.getItem("fromMobileApp") === "true";
    const isFromMobileApp =
      queryFromMobileApp || mobileAppSessionFlag || Boolean(user?.fromMobileApp);
 

  const applyCustomTheme = (theme) => {
  if (!theme) return;

  document.documentElement.style.setProperty('--text-color', theme.text_color);
  document.documentElement.style.setProperty('--ui-color-1', theme.ui_color_1);
  document.documentElement.style.setProperty('--ui-color-2', theme.ui_color_2);
  document.documentElement.style.setProperty('--option-color', theme.option_color);
  document.documentElement.style.setProperty('--option-text-color', theme.option_text_color);
};
    
  useEffect(() => {
      if (/^\/welcome\/?$/.test(location.pathname)) return;
      // Login mounts at `/` and `/login`; skip theme fetch until the user leaves (session + API need a valid token).
      const isLoginRoute =
        location.pathname === "/" || /^\/login\/?$/.test(location.pathname);
      if (!isLoginRoute) {
        if (themeStatus === "idle") {
          dispatch(fetchThemeData({ themeId: null }));
        }
      }
  }, [themeStatus, dispatch, location.pathname]);

  useEffect(()=>{
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])

  const handleMobileLogoClick = (event) => {
    event.preventDefault();
    if (window?.GameStatus?.postMessage) {
      window.GameStatus.postMessage("navigate_back");
    }
  };


  useEffect(() => {
    const isWelcomeGamePath = /^\/welcome\/?$/.test(location.pathname);
    // Welcome.jsx sets body.backgroundImage in an effect. This parent effect runs after the
    // child's (React: child effects first), so clearing here would wipe the game background.
    if (isWelcomeGamePath) return;

    const isLoginPath =
      location.pathname === "/" || /^\/login\/?$/.test(location.pathname);
    const isRulesPath = /^\/rules\/?$/.test(location.pathname);
    const isSorthatPath = /^\/sorthat\/?$/.test(location.pathname);
    const isHousePath = /^\/house\/?$/.test(location.pathname);
    const isCharacterPath = /^\/character\/?$/.test(location.pathname);
    const isWandPath = /^\/wand\/?$/.test(location.pathname);
    const isStage1IntroPath = /^\/stage1_intro\/?$/.test(location.pathname);
    const isThankYouPath = /^\/thankyou\/?$/.test(location.pathname);
    const isLeaderboardPath = /^\/leaderboard\/?$/.test(location.pathname);

    if (
      isLoginPath ||
      isRulesPath ||
      isSorthatPath ||
      isHousePath ||
      isCharacterPath ||
      isWandPath ||
      isStage1IntroPath ||
      isThankYouPath ||
      isLeaderboardPath
    ) {
      const body = document.body;
      body.style.removeProperty("background-image");
      body.style.removeProperty("background-size");
      body.style.removeProperty("background-repeat");
      body.style.removeProperty("background-attachment");
      return;
    }

    if (themeStatus !== "succeeded" || !themeData) return;

    applyCustomTheme(themeData.colors);

    const isWelcomeGame =
      /^\/welcome\/?$/.test(location.pathname) || /^\/fullhouse\/?$/.test(location.pathname);
    if (isWelcomeGame) return;

    const isBroomFlightPath = /^\/stage2\/broom\/?$/.test(location.pathname);
    if (isBroomFlightPath) {
      const body = document.body;
      body.style.removeProperty("background-image");
      body.style.removeProperty("background-size");
      body.style.removeProperty("background-repeat");
      body.style.removeProperty("background-attachment");
      return;
    }

    const applyBodyBackground = () => {
      const body = document.body;
      const bg = window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk;
      const bgUrl = bg ? encodeURI(process.env.REACT_APP_S3_PATH + bg) : null;
      if (bgUrl) {
        body.style.backgroundImage = `url("${bgUrl}")`;
        body.style.backgroundSize = "100% 100%";
        body.style.backgroundRepeat = "no-repeat";
        body.style.backgroundAttachment = "fixed";
      } else {
        body.style.removeProperty("background-image");
      }
    };

    applyBodyBackground();
    window.addEventListener("resize", applyBodyBackground);
    window.addEventListener("orientationchange", applyBodyBackground);
    return () => {
      window.removeEventListener("resize", applyBodyBackground);
      window.removeEventListener("orientationchange", applyBodyBackground);
    };
  }, [themeStatus, themeData, location.pathname]);


  return (
    <>
      <header className="upperaction">
      {isFromMobileApp ? (
        <button type="button" className="logo-button-reset" onClick={handleMobileLogoClick}>
          <img src={logoUrl} className="logo-holder" alt="Company logo" />
        </button>
      ) : (
        <a href={process.env.REACT_APP_BASE_URL}><img src={logoUrl} className="logo-holder" alt="Company logo" /></a>
      )}
        {!isFromMobileApp ? (
          <div className="back-holder">
            <a href={backUrl}><button className="back-default">Back</button></a> 
          </div>
        ) : null}
       
      </header>
      {children}
    </>
  );
}

export default USER;
